import { render, staticRenderFns } from "./TaxGroupListTable.vue?vue&type=template&id=50053809"
import script from "./TaxGroupListTable.vue?vue&type=script&lang=js"
export * from "./TaxGroupListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports